<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.82609 16.7826V19.8261L7.65217 22H5.04348L4.6087 21.5652L5.91304 20.2609L6.34783 19.3913L4.6087 17.6522L3.73913 18.087L2.43478 19.3913L2 18.9565V16.3478L4.17391 14.1739H7.21739L14.1739 7.21739V4.17391L16.3478 2H18.9565L19.3913 2.43478L17.8261 3.91304L17.6522 4.6087L19.3913 6.34783L20.087 6.17391L21.5652 4.6087L22 5.04348V7.65217L19.8261 9.82609H16.7826L9.82609 16.7826Z"
      class="stroke-current"
    />
  </svg>
</template>
